module.exports = __webpack_public_path__ + "static/media/equalicare-img22.f678660e.png";